<template>
<div class="chapter">
<div class="inner_page">
<h1>Tabla de Contenido</h1>
<p><span href="#/c001" title="Link target outside of Sample">Título</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Derechos de Autor</span></p>
<p><a href="#/c003">Tentáculos invasores</a></p>
<p><span href="#/c004" title="Link target outside of Sample">Tus comentarios y recomendaciones son fundamentales</span></p>
<p><span href="#/c005" title="Link target outside of Sample">¿Quieres disfrutar de más buenas lecturas?</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?565f55b4